import { combineReducers } from 'redux';
import profileReducer from './profileReducer';
import factoryReducer from './factoryReducer';

const reducers = combineReducers({
    profile: profileReducer,
    factory: factoryReducer,
});

export default reducers;